// removed by extract-text-webpack-plugin
module.exports = {"CorporateSelect":"CorporateSelect__CorporateSelect___3b7cD","CorporateSelectForm":"CorporateSelect__CorporateSelectForm___OGcXz"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/CorporateSelect/CorporateSelect.less
// module id = 1136
// module chunks = 0 1